import z from 'zod';
export const favoriteIdValue = z.string().trim().min(1)
    .brand('FavoriteId');
export const createFavoriteId = (value) => favoriteIdValue.parse(value);
export const isFavoriteId = (value) => favoriteIdValue.safeParse(value).success;
export const FAVORITE_TARGET_TYPES = [
    'procedure',
    'business_page',
    'convention_collective_nationale',
];
export const favoriteTargetTypeValue = z.enum(FAVORITE_TARGET_TYPES);
export const createFavoriteTargetType = (value) => favoriteTargetTypeValue.parse(value);
export const isFavoriteTargetType = (value) => favoriteTargetTypeValue.safeParse(value).success;
//# sourceMappingURL=ids.js.map